import React from 'react';
import { termsContent } from '../data/termsContent';
import './LegalPage.css';

const Terms: React.FC = () => {
  return (
    <div className="legal-page">
      <div className="container-narrow">
        <div className="legal-header">
          <h1 className="legal-title">이용약관</h1>
          <p className="legal-subtitle">
            {termsContent.serviceName} 서비스 이용약관
          </p>
        </div>

        <div className="legal-content">
          {termsContent.terms.map((section, index) => (
            <div key={index} className="legal-section">
              <h2 className="section-heading">{section.title}</h2>
              <p className="section-content">{section.content}</p>
            </div>
          ))}

          <div className="legal-section company-info">
            <h2 className="section-heading">회사 정보</h2>
            <div className="info-grid">
              <div className="info-item">
                <span className="info-label">회사명</span>
                <span className="info-value">{termsContent.companyName}</span>
              </div>
              <div className="info-item">
                <span className="info-label">대표자</span>
                <span className="info-value">{termsContent.companyInfo.ceo}</span>
              </div>
              <div className="info-item">
                <span className="info-label">사업자등록번호</span>
                <span className="info-value">{termsContent.companyInfo.businessNumber}</span>
              </div>
              <div className="info-item">
                <span className="info-label">본사 / 연구소</span>
                <span className="info-value">{termsContent.companyInfo.headquarters}</span>
              </div>
              <div className="info-item">
                <span className="info-label">서울사무소</span>
                <span className="info-value">{termsContent.companyInfo.researchLab}</span>
              </div>
              <div className="info-item">
                <span className="info-label">전화</span>
                <span className="info-value">{termsContent.companyInfo.tel}</span>
              </div>
              <div className="info-item">
                <span className="info-label">팩스</span>
                <span className="info-value">{termsContent.companyInfo.fax}</span>
              </div>
              <div className="info-item">
                <span className="info-label">이메일</span>
                <span className="info-value">{termsContent.companyInfo.email}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Terms;
